import { useEffect, useState } from 'react'
import { WizardConfig, WizardConfigName, wizardConfigs } from '../wizard-config'

type UseAddAgentWizardConfig = (params: {
  configName: WizardConfigName
}) => UseAddAgentWizardConfigResponse

export interface UseAddAgentWizardConfigResponse {
  wizardConfig: WizardConfig
  updateWizardConfig: (configName: WizardConfigName) => void
}

export const useAddAgentWizardConfig: UseAddAgentWizardConfig = ({
  configName
}) => {
  const [wizardConfig, setWizardConfig] = useState<WizardConfig>(
    wizardConfigs[configName]
  )

  useEffect(() => {
    setWizardConfig(wizardConfigs[configName])
  }, [configName])

  return {
    wizardConfig,
    updateWizardConfig: (newConfigName: WizardConfigName) =>
      setWizardConfig(wizardConfigs[newConfigName])
  }
}
